import {UpdateQueryOptions} from "../../common/state/query.actions";

export class UpdateInventoryQuery {
  static readonly type = '[INVENTORY] Update Query';

  constructor(public options?: UpdateQueryOptions) {
  }
}
